import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import {
	ANIVERSARIO_PREFIX_PATH,
	CUTOFF_ANIVERSARIO_MS,
} from "configs/AppConfig";

const HomeLazy = lazyComReload(() => import("./home"));
const OfertaExpiradaLazy = lazyComReload(() => import("./oferta-expirada"));

export const AniversarioViews = () => {
	const expirada = Date.now() >= CUTOFF_ANIVERSARIO_MS;
	const Component = expirada ? OfertaExpiradaLazy : HomeLazy;

	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${ANIVERSARIO_PREFIX_PATH}/expirada`}
					component={OfertaExpiradaLazy}
				/>
				<Route
					path={`${ANIVERSARIO_PREFIX_PATH}`}
					component={Component}
				/>
				<Redirect
					from={ANIVERSARIO_PREFIX_PATH}
					to={ANIVERSARIO_PREFIX_PATH}
				/>
			</Switch>
		</Suspense>
	);
};

export default AniversarioViews;
